import { toast } from 'sonner';
import { getAttachmentById, getAttachmentUrl, getEncompassDocuments } from './encompassDocumentService';

/** Reserve the tab during the click, before the authorized attachment and signed URL reads. */
export async function openEncompassAttachment(attachmentId: string | undefined, kind: 'invoice' | 'document' = 'invoice', encompassLoanId?: string): Promise<void> {
  const tab = window.open('about:blank', '_blank');
  if (!tab) {
    toast.error('Popup blocked — please allow popups for this site');
    return;
  }
  tab.opener = null;
  try {
    // Delivery queues store the LOS attachment id; fee findings already carry the database UUID.
    // Resolve through the existing loan-scoped reader, never through an unscoped id search.
    let databaseId = attachmentId;
    if (encompassLoanId && attachmentId) {
      const folders = await getEncompassDocuments(encompassLoanId);
      const matches = folders.flatMap(folder => folder.attachments).filter(file => file.attachment_id === attachmentId);
      databaseId = matches.length === 1 ? matches[0].id : undefined;
    }
    const attachment = databaseId ? await getAttachmentById(databaseId) : null;
    if (encompassLoanId && attachment && (attachment.encompass_loan_id !== encompassLoanId || attachment.attachment_id !== attachmentId)) {
      throw new Error('unavailable');
    }
    if (!attachment || attachment.download_status !== 'downloaded' || !attachment.storage_path) {
      throw new Error('unavailable');
    }
    const url = await getAttachmentUrl(attachment.storage_path);
    if (!url) {
      throw new Error('unavailable');
    }
    tab.location.href = url;
  } catch {
    tab.close();
    toast.error(kind === 'invoice' ? 'The invoice file is not available yet.' : 'The document is not available yet.');
  }
}
